import { useState } from 'react';

/**
 * Hook para gerenciar modal de confirmação de PDF
 */
const usePdfConfirmModal = () => {
  const [modalData, setModalData] = useState({
    show: false,
    title: '',
    message: '',
    onConfirm: null,
    isLoading: false,
  });

  const showPdfModal = (title, message, onConfirmCallback) => {
    setModalData({
      show: true,
      title,
      message,
      onConfirm: onConfirmCallback,
      isLoading: false,
    });
  };

  const closePdfModal = () => {
    setModalData(prev => ({
      ...prev,
      show: false,
      isLoading: false,
    }));
  };

  const setLoadingPdf = isLoading => {
    setModalData(prev => ({
      ...prev,
      isLoading,
    }));
  };

  const handleConfirm = async () => {
    if (modalData.onConfirm) {
      setLoadingPdf(true);
      try {
        await modalData.onConfirm();
        closePdfModal();
      } catch (error) {
        console.error('Erro na confirmação do PDF:', error);
        setLoadingPdf(false);
        // O modal permanece aberto para mostrar o erro
      }
    }
  };

  return {
    pdfModalData: modalData,
    showPdfModal,
    closePdfModal,
    setLoadingPdf,
    handleConfirm,
  };
};

export default usePdfConfirmModal;
